<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title1">
    {{title}}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()"></button>
</div>

<div class="modal-body">
  @if (rows.length === 0) {
    <p>No refundable invoice details available.</p>
  } @else {
    <table class="table table-bordered">
      <thead>
        <tr>
          <th style="width: 30px;"></th>
          <th style="width: 100px;">Code</th>
          <th>Items</th>
          <th style="width: 100px;text-align:right">Total(RM)</th>
          <th style="width: 100px;text-align:right">Refundable(RM)</th>
          <th style="width: 140px;">Refund Amount(RM)</th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track row.invoiceDetailsId) {
          <tr>
            <td><input type="checkbox" [(ngModel)]="row.selected" (ngModelChange)="onSelectChange(row)" /></td>
            <td>{{row.accountCode}}</td>
            <td>{{row.description}}</td>
            <td style="text-align:right">{{row.total | number: '1.2-2'}}</td>
            <td style="text-align:right">{{row.remaining | number: '1.2-2'}}</td>
            <td>
              <input type="number" class="form-control" [(ngModel)]="row.amount"
                [disabled]="!row.selected" [max]="row.remaining" min="0.01" step="0.01" />
            </td>
          </tr>
        }
      </tbody>
    </table>

    <form [formGroup]="form">
      <div class="form-group">
        <label for="refundReason">Reason for Refund</label>
        <textarea id="refundReason" class="form-control" rows="2" formControlName="reason"
          [ngClass]="{'is-invalid': submitted && f.reason.errors}"></textarea>
        @if (submitted && f.reason.errors) {
          <div class="invalid-feedback">
            @if (f.reason.errors.required) {
              <div>Reason for refund is required</div>
            }
          </div>
        }
      </div>
    </form>

    @if (errorMessage) {
      <div class="alert alert-danger">{{errorMessage}}</div>
    }
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modalRef.hide()">Cancel</button>
  <button type="button" class="btn btn-primary" [disabled]="rows.length === 0" (click)="onSubmit()">Refund</button>
</div>
